module.exports = __webpack_public_path__ + "img/logo-inverse.f27a2af.svg";